import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, Send } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Checkbox } from '../ui/checkbox';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { API } from './api';

export const RenvoiDialog = ({ exp, headers, onClose, onDone }) => {
  const [options, setOptions] = useState([]);
  const [sel, setSel] = useState(new Set());
  const [extra, setExtra] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    axios.get(`${API}/comptabilite/destinataires`, { headers }).then((r) => {
      const all = [...new Set([...(exp.destinataires || []), ...r.data.par_defaut, ...r.data.comptes_expert])];
      setOptions(all);
      setSel(new Set(exp.destinataires || []));
    }).catch(() => toast.error('Destinataires indisponibles'));
  }, [exp]); // eslint-disable-line react-hooks/exhaustive-deps
  const toggle = (e) => setSel((s) => { const n = new Set(s); n.has(e) ? n.delete(e) : n.add(e); return n; });
  const ajouter = () => {
    const v = extra.trim().toLowerCase();
    if (!v) return;
    setOptions((o) => (o.includes(v) ? o : [...o, v]));
    setSel((s) => new Set([...s, v]));
    setExtra('');
  };
  const envoyer = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/comptabilite/exports/${exp.id}/renvoyer`, { destinataires: [...sel] }, { headers });
      r.data.envoye ? toast.success(`Export ${exp.mois} renvoyé à ${r.data.destinataires} destinataire(s)`) : toast.error("L'envoi de l'e-mail a échoué");
      onDone();
    } catch (e) { toast.error(e.response?.data?.detail || 'Renvoi impossible'); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="renvoi-dialog">
        <DialogHeader>
          <DialogTitle>Renvoyer l'export {exp.mois}</DialogTitle>
          <DialogDescription>Choisissez les destinataires. Le fichier Excel est régénéré avec les données à jour.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {options.map((e) => (
            <label key={e} className="flex items-center gap-2 text-sm cursor-pointer">
              <Checkbox checked={sel.has(e)} onCheckedChange={() => toggle(e)} data-testid={`renvoi-dest-${e}`} /> {e}
            </label>
          ))}
        </div>
        <div className="flex gap-2">
          <Input value={extra} onChange={(e) => setExtra(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && ajouter()} placeholder="Ajouter une adresse e-mail" data-testid="renvoi-extra-input" />
          <Button type="button" variant="outline" onClick={ajouter} data-testid="renvoi-extra-add-btn">Ajouter</Button>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="renvoi-cancel-btn">Annuler</Button>
          <Button onClick={envoyer} disabled={busy || sel.size === 0} className="bg-[#0a3d62] hover:bg-[#0c4a75]" data-testid="renvoi-submit-btn">
            {busy ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Send className="h-4 w-4 mr-2" />} Renvoyer ({sel.size})
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
